import React from 'react'

function MobileMyCase() {
  return (
    <div>Not Available</div>
  )
}

export default MobileMyCase